export default "__VITE_ASSET__BiR1A8Z7__"